import { render, staticRenderFns } from "./modalCompany.vue?vue&type=template&id=fa246aa2&scoped=true&"
import script from "./modalCompany.vue?vue&type=script&lang=js&"
export * from "./modalCompany.vue?vue&type=script&lang=js&"
import style0 from "./modalCompany.vue?vue&type=style&index=0&id=fa246aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa246aa2",
  null
  
)

export default component.exports